module.exports = __webpack_public_path__ + "static/media/27_plantilla_rec_combo_simple_cf_stills_pet_2,25L_aq_man.b65eb4a2.png";